import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import SnowboardShippingPage from '@/v2/components/pages/public-pages/snowboard-shipping-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/snowboard-shipping-page'

interface SnowboardShippingPageProps {}

const Page: React.FC<SnowboardShippingPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.snowboard_shipping.title ?? ''}
        keywords={META_CONTENTS.snowboard_shipping?.keywords ?? ''}
        description={META_CONTENTS.snowboard_shipping?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <SnowboardShippingPage />
    </>
  )
}

export default Page
